import React from 'react';

import { ISearchBarProps } from 'types/components/layouts/shared';

import Desktop from './search-desktop.component';
import Mobile from './search-mobile.component';

const SearchBox: React.FC<ISearchBarProps> = ({ mobile }) => {
  return <React.Fragment>{mobile ? <Mobile /> : <Desktop />}</React.Fragment>;
};

export default SearchBox;
